import { asArray, isRecord, str, type PanelProps } from "../shared";
import { MediaUrlField, StringListField, TextField } from "../shared-ui";
import { getAtPath, setAtPath } from "../path-utils";

export function MetaPanel({ root, disabled, onChangeRoot }: PanelProps) {
  const meta = isRecord(getAtPath(root, "meta"))
    ? (getAtPath(root, "meta") as Record<string, unknown>)
    : {};
  const tags = asArray(meta.tags).map((t) => str(t));

  return (
    <div className="flex flex-col gap-3">
      <TextField
        label="标题"
        value={str(meta.title)}
        disabled={disabled}
        onChange={(v) => onChangeRoot(setAtPath(root, "meta.title", v))}
      />
      <TextField
        label="描述"
        value={str(meta.description)}
        disabled={disabled}
        multiline
        rows={4}
        onChange={(v) => onChangeRoot(setAtPath(root, "meta.description", v))}
      />
      <MediaUrlField
        label="封面 URL"
        value={str(meta.cover)}
        disabled={disabled}
        fieldKey="cover"
        onChange={(v) => onChangeRoot(setAtPath(root, "meta.cover", v))}
      />
      <StringListField
        label="标签"
        value={tags}
        disabled={disabled}
        onChange={(v) =>
          onChangeRoot(
            setAtPath(
              root,
              "meta.tags",
              v.map((s) => s.trim()).filter(Boolean),
            ),
          )
        }
      />
    </div>
  );
}
